export default __webpack_public_path__ + "static/media/Rectangle 373.fedf4d02.png";